import React from 'react';
import { Field } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetEquipmentDropdown } from '../../../../../Core';
import { SieveSetDimensionsFieldSet } from '../../../../Components';
import deepEquals from '../../../../../../../Lib/Object/deepEquals';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ISieveSetDimensions } from 'Data/ViewModels/Equipment/types';
import { Guid } from 'Lib/Guid';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core/WorksheetEquipment';

let PortionSievingEquipmentSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const sieveSetDimensions: ISieveSetDimensions = useSelector(
    createWorksheetSelector!('Equipment.SieveSetDimensions'),
    deepEquals
  );
  const sieveSetImportMismatch = useSelector(createWorksheetSelector!('Equipment.SieveSetImportMismatch')) as boolean;
  const sieveSetId = useSelector(createWorksheetSelector!('Equipment.SieveSet.Id')) as Guid;

  return (
    <NamePrefixModifier appendNamePrefix="Equipment">
      <ListFieldSection>
        <WorksheetBalanceFieldSet label="Balance" name="Balance" />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          name="SieveSet"
          label="Sieve Set"
          equipmentType="sieve-set"
          importedAdditionalData={{
            Dimensions: sieveSetDimensions,
            Mismatch: sieveSetImportMismatch,
          }}
          importModel={{ Id: sieveSetId }}
        />
        <SieveSetDimensionsFieldSet />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

PortionSievingEquipmentSection = withInjectedProps(PortionSievingEquipmentSection);

export { PortionSievingEquipmentSection };
export default PortionSievingEquipmentSection;
